import { TimeRange } from '@sternum/web/components/TimeRangeDropdown';

export const dashboardTimeRanges: TimeRange[] = [
  { unit: 'minutes', offset: 15 },
  { unit: 'days', offset: 1 },
  { unit: 'weeks', offset: 1 },
  { unit: 'months', offset: 1 },
];
